import styled from "styled-components";

import metrics from "../../styles/metrics";

export const Container = styled.div`
  padding: 0 ${metrics.basePadding}px
    ${metrics.footerHeight + metrics.baseMargin}px ${metrics.basePadding}px;
`;
